import * as React from 'react';
import styled from '@emotion/styled';
import { Formik } from 'formik';
import { InputContainerWidget } from '../../../widgets/forms/InputContainerWidget';
import { TextInputType, TextInputWidget } from '../../../widgets/forms/TextInputWidget';
import { ButtonWidget } from '../../../widgets/controls/ButtonWidget';
import { useNavigate } from 'react-router-dom';
import { SessionUserLoaderWidget } from '../../../widgets/content/SessionUserLoaderWidget';
import { SelectInputWidget } from '../../../widgets/forms/SelectInputWidget';
import * as _ from 'lodash';
import { EditProfileRequest, IdentityType, SexualOrientation, RelationshipStatus } from '@foxbun/lib-goferal-types';
import { PUP_RELATIONSHIP_STATUS } from '../../../core/models/ProfileModel';

export const EditProfilePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <S.Container>
      <SessionUserLoaderWidget>
        {({ user }) => {
          return (
            <Formik<EditProfileRequest>
              initialValues={{
                about: user.data.about || '',
                sexual_orientation: user.data.sexual_orientation || SexualOrientation.OTHER,
                relationship_status: user.data.relationship_status,
                identity: user.data.identity || []
              }}
              onSubmit={async (values) => {
                await user.editProfile(values);
                navigate(user.link);
              }}
            >
              {({ values, getFieldHelpers, errors, isValid, isSubmitting, submitForm }) => {
                return (
                  <>
                    <InputContainerWidget label="About" error={errors.about}>
                      <S.About
                        type={TextInputType.PARAGRAPH}
                        value={values.about}
                        onChange={getFieldHelpers('about').setValue}
                      />
                    </InputContainerWidget>
                    <InputContainerWidget label="Sexual orientation" error={errors.about}>
                      <SelectInputWidget
                        value={values.sexual_orientation}
                        onChange={getFieldHelpers('sexual_orientation').setValue}
                        options={_.map(SexualOrientation, (orientation) => {
                          return {
                            key: orientation,
                            title: _.capitalize(orientation)
                          };
                        })}
                      />
                    </InputContainerWidget>
                    <InputContainerWidget label="Identity" error={errors.about}>
                      <SelectInputWidget
                        value={values.identity.length > 1 ? 'both' : values.identity[0]}
                        onChange={(value) => {
                          if (value === IdentityType.PUP || value === IdentityType.HANDLER) {
                            getFieldHelpers('identity').setValue([value]);
                          } else {
                            getFieldHelpers('identity').setValue([IdentityType.PUP, IdentityType.HANDLER]);
                          }
                        }}
                        options={[
                          {
                            key: IdentityType.PUP,
                            title: 'Pup'
                          },
                          {
                            key: IdentityType.HANDLER,
                            title: 'Handler'
                          },
                          {
                            key: 'both',
                            title: 'Both'
                          }
                        ]}
                      />
                    </InputContainerWidget>
                    <InputContainerWidget label="Relationship status" error={errors.about}>
                      <SelectInputWidget
                        value={values.relationship_status}
                        onChange={getFieldHelpers('relationship_status').setValue}
                        options={_.map(RelationshipStatus, (orientation) => {
                          if (values.identity.includes(IdentityType.PUP)) {
                            return {
                              key: orientation,
                              title: _.capitalize(PUP_RELATIONSHIP_STATUS[orientation] || orientation)
                            };
                          }

                          return {
                            key: orientation,
                            title: _.capitalize(orientation)
                          };
                        })}
                      />
                    </InputContainerWidget>
                    <ButtonWidget
                      disabled={!isValid}
                      loading={isSubmitting}
                      label="Save"
                      action={() => {
                        submitForm();
                      }}
                    />
                  </>
                );
              }}
            </Formik>
          );
        }}
      </SessionUserLoaderWidget>
    </S.Container>
  );
};
namespace S {
  export const About = styled(TextInputWidget)`
    height: 400px;
  `;

  export const Container = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    overflow: auto;
  `;
}
